import * as Sentry from '@sentry/react'

import { environments } from '@percent/workplace-giving/constants/environments'

// eslint-disable-next-line no-console
const consoleErr = (value: unknown) => console.log(value)

const isMonitoredEnvironment = () => {
  switch (process.env.NX_PUBLIC_REACT_APP_ENV) {
    case environments.SANDBOX:
    case environments.STAGING:
    case environments.PREPROD:
    case environments.PRODUCTION:
      return true
    default:
      return false
  }
}

export const logger = (error: Error) => {
  if (isMonitoredEnvironment()) {
    return Sentry.captureException(error)
  }

  return consoleErr(error)
}

export const RATE_LIMIT_SENTRY_MESSAGE = 'API rate limit hit (HTTP 429)'

export const logRateLimitHit = () => {
  if (isMonitoredEnvironment()) {
    return Sentry.captureMessage(RATE_LIMIT_SENTRY_MESSAGE, {
      level: 'warning',
      tags: {
        httpStatus: 429,
        rateLimited: true
      }
    })
  }

  return consoleErr(RATE_LIMIT_SENTRY_MESSAGE)
}
